<template>
  <el-menu background-color="#eaeefb" text-color="#009ACE" mode="horizontal">
    <el-submenu index="31">
      <template slot="title">PEAs</template>
      <router-link v-show="this.isAdmin || this.isServiceDesk" :to="{path: '/adminArea/changeOwner'}">
        <el-menu-item index="31-1">
          Change PEA Owner
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin || this.isServiceDesk" to="/adminArea/peaChangeStatus">
        <el-menu-item index="31-2">
          Change PEA status
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" :to="{path: '/adminArea/adminDivisionAccess'}">
        <el-menu-item index="31-3">
          View & Change Division Access
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" to="/adminArea/adminViewPeaNotificationsByUser">
        <el-menu-item index="31-4">
          View & Change User Notifications
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" to="/adminArea/peaChangeCheckNotifications">
        <el-menu-item index="31-5">
          PEA Check Notifications
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" :to="{path: '/adminArea/viewAdminsByDivision'}">
        <el-menu-item index="32-5">
          View Admins List by Division
        </el-menu-item>
      </router-link>
    </el-submenu>
    <el-submenu index="32">
      <template slot="title">Approvals</template>
      <router-link v-show="this.isAdmin" :to="{path: '/adminArea/adminViewPeaApproversByPEA'}">
        <el-menu-item index="32-1">
          View & Change Approvers for a PEA
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" :to="{path: '/adminArea/PEAApprovalRolesAndRules'}">
        <el-menu-item index="32-2">
          View/Update Existing Approval Rules
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" :to="{path: '/adminArea/createApprovalRule'}">
        <el-menu-item index="32-3">
          Create New Approval Rule
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin || this.isServiceDesk" :to="{path: '/adminArea/peaApprovalRolesAndUsers'}">
        <el-menu-item index="32-4">
          View/Update Existing Approval User Role List
        </el-menu-item>
      </router-link>
      <router-link v-show="this.isAdmin" :to="{path: '/adminArea/createApprovalUserRole'}">
        <el-menu-item index="32-5">
          Create New Approval User Role
        </el-menu-item>
      </router-link>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: 'adminNav',
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    isServiceDesk () {
      return this.$store.getters.isServiceDesk
    }
  }
}
</script>
